import {HttpErrorResponse} from '@angular/common/http';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ModalSize, OverlayService} from '@aztrix/components/overlay';
import {BehaviorSubject, first, Observable} from 'rxjs';

import {RetryVerificationComponent} from './retry-verification/retry-verification.component';

@Component({
  selector: 'ax-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
})
export class OtpVerificationComponent implements OnInit {
  @Input() verified = false;
  @Input() verificationValue: string | undefined = '';
  @Input() verificationType: 'EMAIL' | 'MOBILE';
  @Input() canChangeValue = true;
  @Input() verificationCode?: string;
  @Input() verificationButtonColor: 'accent' | 'primary' = 'accent';
  @Input() startDate: number | undefined = Date.now();
  @Input() autoVerification = true;

  @Input() verification: (code: string, verificationValue: string) => Observable<any>;
  @Input() retryVerification: (verificationValue: string) => Observable<unknown>;

  @Output() verificationValueChanges = new EventEmitter<string>();
  @Output() verificationComplete = new EventEmitter<any>();

  codeForm = new FormControl<string | null>({value: null, disabled: false}, [Validators.required]);

  loading$ = new BehaviorSubject(false);
  error$ = new BehaviorSubject<string | boolean | null>(null);

  constructor(
    private _overlay: OverlayService,
    private _elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    if (this.verificationCode && !this.verified && this.verificationValue !== '') {
      this.codeForm.setValue(this.verificationCode);
      if (this.autoVerification) {
        this.verifyOTP();
      }
    }
  }

  verifyOTP() {
    if (this.codeForm?.errors) {
      return;
    }

    this.loading$.next(true);
    this.error$.next(null);

    this.verification(<string>this.codeForm.value, this.verificationValue || '')
      .pipe(first())
      .subscribe({
        next: (response) => {
          this.verified = true;
          this.loading$.next(false);
          this.verificationComplete.next(response);
        },
        error: (response: HttpErrorResponse) => {
          this.codeForm.reset();

          this.error$.next(typeof response.error === 'string' ? response.error : true);
          this.loading$.next(false);
        },
      });
  }

  retryOTP() {
    this._overlay.createModal(this._elementRef, RetryVerificationComponent, {
      title: 'agreement.verification.send',
      modalSize: ModalSize.COMPACT_EXTRA_SMALL,
      init: (modal) => {
        modal.startDate = this.startDate;
        modal.canChangeValue = this.canChangeValue;
        modal.verificationType = this.verificationType;
        modal.retryVerification = this.retryVerification;
        modal.form.setValue(this.verificationValue || '');
        modal.verificationValueChanges.pipe(first()).subscribe((verificationValue) => {
          this.verificationValue = verificationValue;
          this.verificationValueChanges.next(this.verificationValue);
          this.error$.next(null);
        });
      },
    });
  }
}
